import { useCurrency, SUPPORTED_CURRENCIES } from "@/context/CurrencyContext";
import { ChevronDown } from "lucide-react";
import { useState, useRef, useEffect } from "react";

export default function CurrencySwitcher({ compact = false }) {
  const { currency, setCurrency, symbols } = useCurrency();
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const handler = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, []);

  return (
    <div className="relative" ref={ref}>
      <button
        data-testid="currency-switcher-btn"
        onClick={() => setOpen((v) => !v)}
        className={`flex items-center gap-1.5 px-3 py-1.5 rounded-full border border-slate-200 hover:border-slate-300 bg-white text-sm font-semibold text-slate-700 transition-all ${compact ? "" : "min-w-[88px]"}`}
        title="Switch currency"
      >
        <span className="text-slate-400">{symbols[currency] || ""}</span>
        <span>{currency}</span>
        <ChevronDown className="w-3.5 h-3.5 text-slate-400" />
      </button>
      {open && (
        <div className="absolute right-0 mt-2 w-44 bg-white border border-slate-200 rounded-xl shadow-xl py-2 z-50 max-h-72 overflow-auto">
          {SUPPORTED_CURRENCIES.map((c) => (
            <button
              key={c}
              data-testid={`currency-option-${c}`}
              onClick={() => {
                setCurrency(c);
                setOpen(false);
              }}
              className={`w-full text-left px-3 py-1.5 text-sm flex items-center justify-between hover:bg-slate-50 ${
                c === currency ? "text-[#E11D48] font-bold" : "text-slate-700"
              }`}
            >
              <span>
                <span className="text-slate-400 mr-2">{symbols[c]}</span>
                {c}
              </span>
              {c === currency && <span className="text-[10px] uppercase tracking-wider">●</span>}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
